const selectedRegionColor = [222, 113, 6]
const allRegionsColor = [39, 128, 204]
const referenceRegionsColor = [73, 203, 174]
const sameCountryRegionsColor = [208, 126, 166]

const otherRegionsColors = [
  [15, 164, 196],
  [200, 8, 21],
  [251, 54, 64],
  [41, 49, 50],
  [234, 191, 203],
  [35, 100, 170],
  [183, 240, 173],
  [175, 43, 191]
]

const mapMaxColorDescending = [14, 88, 151]
const mapMinColorDescending = [255, 255, 255]
const mapMaxColorDescendingFemale = [38, 5, 183]
const mapMinColorDescendingFemale = [255, 255, 255]

const mapMaxColorAscending = [200, 8, 21]
const mapMinColorAscending = [255, 255, 255]
const mapMaxColorAscendingFemale = [247, 82, 22]
const mapMinColorAscendingFemale = [255, 255, 255]

const colorToRGBA = (color, a = 1) => {
  return 'rgba(' + color[0] + ',' + color[1] + ',' + color[2] + ',' + a + ')'
}

const selectOtherRegionsColor = index => {
  let realIndex = index
  if (index > otherRegionsColors.length - 1) {
    realIndex = index - otherRegionsColors.length
  }
  return otherRegionsColors[realIndex]
}

const REGION_COLORS = {
  1: [214, 136, 61], // ES21
  326: [111, 145, 198], // DE1
  560: [103, 159, 169], // AT3º
  411: [185, 73, 63], // ES
  325: [0, 95, 170], // DE
  2692: [188, 125, 214] // EU27_2020
};

const getColorByRegionId = ( regionId ) => {
  if ( regionId in REGION_COLORS ) {
    return REGION_COLORS[ regionId ];
  }
  return otherRegionsColors[ regionId % otherRegionsColors.length ];
};

const colors = {
  selectedRegionColor,
  allRegionsColor,
  referenceRegionsColor,
  sameCountryRegionsColor,
  mapMaxColorDescending,
  mapMinColorDescending,
  mapMaxColorDescendingFemale,
  mapMinColorDescendingFemale,
  mapMaxColorAscending,
  mapMinColorAscending,
  mapMaxColorAscendingFemale,
  mapMinColorAscendingFemale,
  colorToRGBA,
  selectOtherRegionsColor,
  getColorByRegionId
}

export default colors



// WEBPACK FOOTER //
// ./src/utils/colors/colors.js